import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../themes/Default/components/List";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { Filter as ListFilter } from "../../themes/Default/components/List/components/Header/components/Filter";
import { Menu as ListMenu } from "../../themes/Default/components/List/components/Header/components/Menu";
import { Button as ListMenuButton } from "../../themes/Default/components/List/components/Header/components/Menu/components/Button";
import { Pagination } from "../../themes/Default/components/List/components/Footer/components/Pagination";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Checkbox } from "../../themes/Default/components/Form/components/Checkbox";
import { getNumberOfUsedFilters } from "../../services/utils/Filter";
import { useTranslation } from "react-i18next";
import { Toaster } from "../../themes/Default/components/Toaster";
import { roles } from "../../services/utils/Roles";
import { useUserToken } from "../../hooks/core/UserToken";
import { callsManagement } from "../../hooks/api/CallsManagement";
import { Formik } from "formik";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";
import { prepareSelect } from "../../services/core/Select";
import { locationsManagement } from "../../hooks/api/LocationsManagement";
import { usePersistentFilters } from "../../hooks/core/PersistentFilters";
import DatePicker from "../../themes/Default/components/Form/components/DatePicker/DatePicker";

const Calls = () => {
    const { t } = useTranslation("common");
    const recordsPerPage = 50;
    const defaultFilters = {
        startPage: 0,
        limitPage: recordsPerPage,
    };
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [filters, setFilters, resetFilters] = usePersistentFilters("callsFilters", defaultFilters);
    const [currentPage, setCurrentPage] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [disableDelete, setDisableDelete] = useState(true);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [numberOfUserdFilters, setNumberOfUserdFilters] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [calls, setCalls] = useState();
    const { useCallsListMutation, useDeleteCallMutation, useExportCallsMutation } = callsManagement;
    const [callList] = useCallsListMutation();
    const [deleteCall] = useDeleteCallMutation();
    const [exportCalls] = useExportCallsMutation();

    const [courseType, setCourseType] = useState([]);
    const { useCourseTypeListMutation } = settingsCallManagement;
    const [courseTypeList] = useCourseTypeListMutation();

    const [locations, setLocations] = useState([]);
    const { useLocationListMutation } = locationsManagement;
    const [locationsList] = useLocationListMutation();

    const [studentStatus, setStudentStatus] = useState([]);
    const { useStudentStatusListMutation } = settingsCallManagement;
    const [studentStatusList] = useStudentStatusListMutation();

    const [appointment, setAppointment] = useState([]);
    const { useAppointmentListMutation } = settingsCallManagement;
    const [appointmentList] = useAppointmentListMutation();

    const [salesChannel, setSalesChannel] = useState([]);
    const { useSalesChannelListMutation } = settingsCallManagement;
    const [salesChannelList] = useSalesChannelListMutation();

    const [methodOfContact, setMethodOfContact] = useState([]);
    const { useMethodOfContactListMutation } = settingsCallManagement;
    const [methodOfContactList] = useMethodOfContactListMutation();

    const [status, setStatus] = useState([]);
    const { useStatusListMutation } = settingsCallManagement;
    const [statusList] = useStatusListMutation();

    const openFilter = () => {
        setShowFilter(true);
    };

    const closeFilter = () => {
        setShowFilter(false);
    };

    const gotoNew = () => {
        navigate("/calls/add");
    };

    const gotoEdit = (callId) => {
        navigate("/calls/edit/" + callId);
    };

    const onFilter = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onFiltered = (values) => {
        setFilters({
            ...filters,
            firstName: values.firstName,
            lastName: values.lastName,
            grade: values.grade,
            guardian1FirstName: values.guardian1FirstName,
            guardian1LastName: values.guardian1LastName,
            guardian1PhoneNumber:values.guardian1PhoneNumber,
            courseType: values.courseType,
            location: values.location,
            studentStatus: values.studentStatus,
            appointment: values.appointment,
            salesChannel: values.salesChannel,
            methodOfContact: values.methodOfContact,
            status: values.status,
            student: values.student,
            guardian1Email: values.guardian1Email,
            hasContract: values.hasContract,
            signeContract: values.signeContract,
            hasGroup: values.hasGroup,
            dateFrom: values?.dateFrom,
            dateTo: values?.dateTo
        });
    };

    const onPageChange = (currentPage) => {
        setCurrentPage(currentPage);
        const newStartPage = (currentPage - 1) * recordsPerPage;
        setFilters({
            ...filters,
            startPage: newStartPage,
            limitPage: recordsPerPage,
        });
    };

    const onSelectionChange = (id) => {
        setSelectedStudents((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedStudents?.length; i++) {
                            const studentId = selectedStudents[i];
                            deleteCall(studentId).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    callList(filters).then((result) => {
                                        const students = result?.data?.records;
                                        setCalls(students);
                                        setTotalRecords(result?.data?.totalRecords);
                                    });
                                    setDisableDelete(true);
                                    toast.info(result?.data?.info?.responseMessage);
                                    onSelectionChange(studentId);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onExport = async () => {
        const blob = await exportCalls().unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const today = new Date().toISOString().split('T')[0];
        link.download = `Calls_${today}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    useEffect(() => {
        if (selectedStudents.length > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
    }, [selectedStudents]);

    useEffect(() => {
        callList(filters).then((result) => {
            const calls = result?.data?.records;
            setCalls(calls);

            setTotalRecords(result?.data?.totalRecords);
        });
        setNumberOfUserdFilters(getNumberOfUsedFilters(filters));

        courseTypeList().then((result) => {
            let options = [];
            result?.data?.records.map((courseType) => {
                options.push({
                    id: courseType.id,
                    name: courseType.name,
                });
            });
            setCourseType(prepareSelect(options));
        });

        locationsList().then((result) => {
            let options = [];
            result?.data?.records.map((location) => {
                options.push({
                    id: location.id,
                    name: location.name,
                });
            });
            setLocations(prepareSelect(options));
        });
        studentStatusList().then((result) => {
            let options = [];
            result?.data?.records.map((studentStatus) => {
                options.push({
                    id: studentStatus.id,
                    name: studentStatus.status,
                });
            });
            setStudentStatus(prepareSelect(options));
        });
        appointmentList().then((result) => {
            let options = [];
            result?.data?.records.map((appointment) => {
                options.push({
                    id: appointment.id,
                    name: appointment.name,
                });
            });
            setAppointment(prepareSelect(options));
        });
        salesChannelList().then((result) => {
            let options = [];
            result?.data?.records.map((salesChannel) => {
                options.push({
                    id: salesChannel.id,
                    name: salesChannel.name,
                });
            });
            setSalesChannel(prepareSelect(options));
        });
        methodOfContactList().then((result) => {
            let options = [];
            result?.data?.records.map((methodOfContact) => {
                options.push({
                    id: methodOfContact.id,
                    name: methodOfContact.name,
                });
            });
            setMethodOfContact(prepareSelect(options));
        });
        statusList().then((result) => {
            let options = [];
            result?.data?.records.map((status) => {
                options.push({
                    id: status.id,
                    name: status.status,
                });
            });
            setStatus(prepareSelect(options));
        });
    }, [filters, callList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                    <>
                        <Button title={t("calls.add")} icon="fa-regular fa-plus" onClick={gotoNew}></Button>
                        <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={disableDelete} onClick={onDelete}></Button>
                    </>
                )} 
                <Button title={t("export")} icon="fa-regular fa-cloud-arrow-down" onClick={onExport}></Button>
            </TopNavigation>
            <Main>
                <Title>{`${t("calls.title")} (${totalRecords})`}</Title>
                <Breadcrumps>
                    <Link title={t("calls.title")} icon="fa-user-graduate" />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                <List>
                    <ListHeader>
                        <ListMenu>
                            <ListMenuButton title="Filter" icon="fa-filter" onClick={openFilter} badge={numberOfUserdFilters} />
                        </ListMenu>
                        <ListFilter isVisible={showFilter} onClose={closeFilter} onFilter={onFilter} onResetFilter={resetFilters}>
                            <Formik
                                innerRef={formRef}
                                initialValues={{
                                    firstName: filters?.firstName,
                                    lastName: filters?.lastName,
                                    grade: filters?.grade,
                                    guardian1FirstName: filters?.guardian1FirstName,
                                    guardian1LastName: filters?.guardian1LastName,
                                    guardian1PhoneNumber:filters?.guardian1PhoneNumber,
                                    courseType: filters?.courseType,
                                    location: filters?.location,
                                    studentStatus: filters?.studentStatus,
                                    appointment: filters?.appointment,
                                    salesChannel: filters?.salesChannel,
                                    methodOfContact: filters?.methodOfContact,
                                    status: filters?.status,
                                    student: filters?.student,
                                    guardian1Email: filters?.guardian1Email,
                                    hasContract: filters?.hasContract,
                                    signeContract: filters?.signeContract,
                                    hasGroup: filters?.hasGroup,
                                    dateFrom: filters?.dateFrom,
                                    dateTo: filters?.dateTo
                                }}
                                onSubmit={onFiltered}
                            >
                                {({ values, handleChange, handleSubmit, resetForm }) => (
                                    <Form>
                                         {(decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                                        decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                                        decodedToken?.roles.includes(roles.DIRECTOR) ||
                                        decodedToken?.roles.includes(roles.SECRETARY)) ? (
                                            <>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="firstName"
                                                            label={t("students.firstName")}
                                                            value={values.firstName}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input 
                                                            name="lastName" 
                                                            label={t("students.lastName")} 
                                                            value={values.lastName} 
                                                            onChange={handleChange} 
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="guardian1Email"
                                                            label={t("students.emailAddress")}
                                                            value={values.guardian1Email}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="grade"
                                                            label={t("students.grade")}
                                                            value={values.grade}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="guardian1FirstName"
                                                            label={t("students.guardian1FirstName")}
                                                            value={values.guardian1FirstName}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="guardian1LastName"
                                                            label={t("students.guardian1LastName")}
                                                            value={values.guardian1LastName}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="guardian1PhoneNumber"
                                                            label={t("students.guardian1PhoneNumber")}
                                                            value={values.guardian1PhoneNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="courseType"
                                                            label={t("students.contractGroupType")}
                                                            options={courseType}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.courseType}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="location"
                                                            label={t("groups.location")}
                                                            options={locations}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.location}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="student"
                                                            label={t("calls.student")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.student}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>  
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="hasContract"
                                                            label={t("Postoji ugovor")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.hasContract}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="signeContract"
                                                            label={t("Potpisan ugovor")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.signeContract}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="hasGroup"
                                                            label={t("Postoji grupa")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.hasGroup}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>  
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="dateFrom"
                                                            label={t("Datum od")}
                                                            value={values.dateFrom ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>  
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="dateTo"
                                                            label={t("Datum do")}
                                                            value={values.dateTo ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>                                         
                                            </>
                                        ) : (
                                            <>
                                            <Row>
                                                    <Field>
                                                        <Input
                                                            name="grade"
                                                            label={t("students.grade")}
                                                            value={values.grade}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="studentStatus"
                                                            label={t("calls.old/new")}
                                                            options={studentStatus}
                                                            onChange={handleChange}
                                                            selectedValue={values.studentStatus}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="courseType"
                                                            label={t("students.contractGroupType")}
                                                            options={courseType}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.courseType}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="appointment"
                                                            label={t("groups.classStartTime")}
                                                            options={appointment}
                                                            onChange={handleChange}
                                                            selectedValue={values.appointment}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="location"
                                                            label={t("groups.location")}
                                                            options={locations}
                                                            onChange={handleChange}
                                                            selectedValue={values.location}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="salesChannel"
                                                            label={t("calls.saleChannel")}
                                                            options={salesChannel}
                                                            onChange={handleChange}
                                                            selectedValue={values.salesChannel}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="methodOfContact"
                                                            label={t("calls.methodOfContacts")}
                                                            options={methodOfContact}
                                                            onChange={handleChange}
                                                            selectedValue={values.methodOfContact}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="status"
                                                            label={t("status")}
                                                            options={status}
                                                            onChange={handleChange}
                                                            selectedValue={values.status}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row> 
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="student"
                                                            label={t("calls.student")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.student}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row> 
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="hasContract"
                                                            label={t("Postoji ugovor")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.hasContract}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="signeContract"
                                                            label={t("Potpisan ugovor")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.signeContract}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="hasGroup"
                                                            label={t("Postoji grupa")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.hasGroup}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="dateFrom"
                                                            label={t("Datum od")}
                                                            value={values.dateFrom ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>  
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="dateTo"
                                                            label={t("Datum do")}
                                                            value={values.dateTo ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row> 
                                            </>
                                        )}  
                                    </Form>
                                )}
                            </Formik>
                        </ListFilter>
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                                    decodedToken?.roles.includes(roles.DIRECTOR) ||
                                    decodedToken?.roles.includes(roles.SECRETARY)) ? (
                                        <>
                                            <TableHeadCell></TableHeadCell>
                                            <TableHeadCell></TableHeadCell> 
                                            <TableHeadCell>
                                                <span>{t("test.date")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.firstName")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.lastName")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.grade")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.guardian")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.phoneNumber")}</span>
                                            </TableHeadCell>
                                            {/* <TableHeadCell>
                                                <span>{t("students.contractGroupType")}</span>
                                            </TableHeadCell> */}
                                            <TableHeadCell>
                                                <span>{t("program.language")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("test.locationName")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("Status poziva")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.createdBy")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.student")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.title")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("Ugovori")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell></TableHeadCell>                                                
                                        </>
                                    ) : (
                                        <>
                                        <TableHeadCell></TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("test.date")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("students.grade")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.old/new")}</span>
                                            </TableHeadCell>
                                            {/* <TableHeadCell>
                                                <span>{t("students.contractGroupType")}</span>
                                            </TableHeadCell> */}
                                            <TableHeadCell>
                                                <span>{t("program.language")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.classStartTime")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("test.locationName")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.saleChannel")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.methodOfContacts")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("Status poziva")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calls.student")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.title")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("Ugovori")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("calendar.note")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell></TableHeadCell> 
                                        </>
                                    )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {calls?.length > 0 &&
                                calls?.map((call, index) => {
                                    return (
                                        <TableRow key={call.id}>
                                            {(decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                                            decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) ||
                                            decodedToken?.roles.includes(roles.DIRECTOR) ||
                                            decodedToken?.roles.includes(roles.SECRETARY)) ? (
                                                <>
                                                    <TableDataCell>
                                                        <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(call.id)}></Button>
                                                    </TableDataCell>  
                                                    <TableDataCell>
                                                        <Checkbox name="isBlockClass" value={call.id} onChange={() => onSelectionChange(call.id)} />
                                                    </TableDataCell>
                                                    <TableDataCell>{call.date}</TableDataCell>
                                                    <TableDataCell>{call.firstName}</TableDataCell>
                                                    <TableDataCell>{call.lastName}</TableDataCell>
                                                    <TableDataCell>{call.grade}</TableDataCell>
                                                    <TableDataCell>
                                                        {(call.guardian1FirstName || call.guardian1LastName) 
                                                        ? `${call.guardian1FirstName ?? ''} ${call.guardian1LastName ?? ''}`.trim()
                                                        : ''}
                                                    </TableDataCell>
                                                    <TableDataCell>{call.guardian1PhoneNumber}</TableDataCell>
                                                    {/* <TableDataCell>{call.courseTypeName}</TableDataCell> */}
                                                    <TableDataCell>{call.languageName}</TableDataCell>
                                                    <TableDataCell>{call.locationName}</TableDataCell>
                                                    <TableDataCell>{call.statusName}</TableDataCell>
                                                    <TableDataCell>{call.createdByUsername}</TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: call.studentId ? '#27ae60' : '#ff0000' }}>
                                                            {call.studentId ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell title={call.groups?.filter(g => g.studentStatus === false).map(g => g.name).join('\n') || ''}>
                                                        {call.groupsCount > 0 ? call.groupsCount : ''}
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: call.signeContract === call.totalContract ? '#27ae60' : '#ff0000' }}>
                                                            {(call.totalContract > 0) ? call.signeContract + '/' + call.totalContract : ''}
                                                        </span>
                                                    </TableDataCell> 
                                                    <TableDataCell></TableDataCell>                                  
                                                </>
                                            ) : (
                                                <>
                                                    <TableDataCell>
                                                        <Checkbox name="isBlockClass" value={call.id} onChange={() => onSelectionChange(call.id)} />
                                                    </TableDataCell>
                                                    <TableDataCell>{call.date}</TableDataCell>
                                                    <TableDataCell>{call.grade}</TableDataCell>
                                                    <TableDataCell>{call.studentStatusName}</TableDataCell>
                                                    {/* <TableDataCell>{call.courseTypeName}</TableDataCell> */}
                                                    <TableDataCell>{call.languageName}</TableDataCell>
                                                    <TableDataCell>{call.appointmentName}</TableDataCell>
                                                    <TableDataCell>{call.locationName}</TableDataCell>
                                                    <TableDataCell>{call.salesChannelName}</TableDataCell>
                                                    <TableDataCell>{call.methodOfContactName}</TableDataCell>
                                                    <TableDataCell>{call.statusName}</TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: call.studentId ? '#27ae60' : '#ff0000' }}>
                                                            {call.studentId ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell title={call.groups?.filter(g => g.studentStatus === false).map(g => g.name).join('\n') || ''}>
                                                        {call.groupsCount > 0 ? call.groupsCount : ''}
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: call.signeContract === call.totalContract ? '#27ae60' : '#ff0000' }}>
                                                            {(call.totalContract > 0) ? call.signeContract + '/' + call.totalContract : ''}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>{call.note}</TableDataCell>
                                                    <TableDataCell>
                                                    </TableDataCell>
                                                </>
                                            )}
                                            
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </ListBody>
                </List>
                <Pagination currentPage={currentPage} recordsPerPage={recordsPerPage} totalRecords={totalRecords} onClick={onPageChange} />
            </Main>
        </DefaultLayout>
    );
};

export default Calls;
